// core/event-bus.ts — Platik-IA
// Bus de eventos tipado. Única vía de comunicación entre módulos.
// Los módulos NO se importan entre sí — todo pasa por aquí.

import mitt from 'mitt';
import type { AuthEvents }          from '../modules/auth/events';
import type { NotificationEvents }  from '../modules/notifications/events';
import type { CategoryEvents }      from '../modules/categories/events';
import type { SyncEvents }          from '../modules/sync/events';
import type { TransactionEvents }   from '../modules/transactions/events';
import type { VoiceEvents }         from '../modules/voice/events';
import type { AnalyticsEvents }     from '../modules/analytics/events';
import type { NavigationEvents }    from '../modules/navigation/events';
import type { SettingsEvents }      from '../modules/settings/events';
import type { ImportEvents }        from '../modules/import/events';
import type { AdminEvents }         from '../modules/admin/events';

export interface CoreEvents {
  'module:ready': { name: string };
  'module:error': { name: string; error: Error };
  'app:ready':    void;
  'app:error':    { error: Error };
}

export type AppEvents =
  CoreEvents &
  AuthEvents &
  NotificationEvents &
  CategoryEvents &
  SyncEvents &
  TransactionEvents &
  VoiceEvents &
  AnalyticsEvents &
  NavigationEvents &
  SettingsEvents &
  ImportEvents &
  AdminEvents &
  Record<string | symbol, unknown>;

export const bus = mitt<AppEvents>();
